import React, { useCallback, useMemo } from 'react'
import { Button, View, Text } from '@/components'
import { TypeGuards } from '@codeleap/types'
import { Alert, modal, AlertOptions } from '@codeleap/modals'
// import { t } from '@lingui/core/macro'

const optionStyleMap = {
  'destructive': 'negativePrimary',
  'outline': 'regularTerciary',
  'minimal': 'regularQuaternary',
  'cancel': 'neutralSecondary',
}

Alert.modal = modal<AlertOptions>({ id: 'global-alert' }).content(props => {
  const { title, body, options, onDismiss, toggle, titleStyle, bodyStyle } = props

  const alertOptions = useMemo(() => {
    return options?.filter(Boolean)?.map(o => ({ debugName: o?.text, ...o, style: optionStyleMap[o?.style] ?? o?.style }))
  }, [options])

  const handleDismiss = useCallback(() => {
    toggle()
    if (TypeGuards.isFunction(onDismiss)) onDismiss?.()
  }, [onDismiss])

  const renderOption = useCallback((buttonProps: any, index: number) => {
    const handlePress = () => {
      toggle()
      if (TypeGuards.isFunction(buttonProps?.onPress)) buttonProps?.onPress?.()
    }

    return (
      <Button
        {...buttonProps}
        style={['flex', buttonProps?.style]}
        onPress={handlePress}
        key={'alert' + buttonProps?.text + index}
      />
    )
  }, [])

  return <View style={['column', 'center', 'gap:1']}>
    {title ? <Text style={[titleStyle || 'h4', 'textCenter']} text={title} /> : null}

    {body ? <Text style={[bodyStyle || 'p3', 'textCenter']} text={body} /> : null}

    <View style={[alertOptions?.length > 2 ? 'column' : 'row', 'gap:2', 'fullWidth', 'marginTop:2']}>
      {
        alertOptions?.length >= 1
          ? alertOptions?.map(renderOption)
          : (
            <Button
              text={`Dismiss`}
              debugName='Dismiss button from alert modal'
              style={['regularTerciary', 'flex']}
              onPress={handleDismiss}
            />
          )
      }
    </View>
  </View>
}).props({
  style: ['box:responsiveness'],
})

Alert.openAlert = () => {
  return Alert.modal.props({ closable: false, showClose: false, style: ['centered', 'box:responsiveness'] })
}
